<template>
  <div />
</template>

<script>
import my from '../../assets/js/lbc'
import { GetOpenID, tokenFromOpenId } from '@/api/public'
export default {
  data() {
    return {
    }
  },
  created() {
    this.codeToOpenid()
  },
  methods: {
    // 获取openid
    codeToOpenid() {
      console.log('进入loginInfo页面，开始获取openid并登录')
      // 微信公众号appid-开发-基本配置中获取
      const appId = my.appId; const toPath = my.host + '/#' + this.$route.path
      // 核心步骤，获取code
      const hrefurl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
        appId + '&redirect_uri=' + encodeURIComponent(toPath) + '&response_type=code&scope=snsapi_base&state=#wechat_redirect'
      // 从地址栏获取code
      const code = my.getQueryString('code')
      console.log('loginInfo 页面 code=', code)
      if (code) {
        GetOpenID(code).then(res => {
          if (res.code === 20005) {
            this.$toast.clear(true); sessionStorage.setItem('jump', true); window.location.replace(hrefurl)
          } else {
            localStorage.setItem('openId', res.data.openid)
            console.log('loginInfo 页面 openId=', res.data.openid)
            // 从服务端查询到token 说明已登录 需要存储token 并跳转回原页面
            tokenFromOpenId({ openId: res.data.openid }).then(res2 => {
              if (parseInt(res2.data.categoryIdType) === 1) {
                if (res2.data.ssoToken) {
                  console.log('loginInfo 页面 ssoToken=', res2.data.ssoToken)
                  localStorage.setItem('token', res2.data.ssoToken)
                  // 跳转回原页面
                  const jumpBackPath = sessionStorage.getItem('jumpBackPath') || '/home/index'
                  sessionStorage.removeItem('jumpBackPath')
                  window.location.replace(my.host + '/#' + jumpBackPath)
                } else {
                  // 未登录 跳转回登录页
                  window.location.replace(my.host + '/#/user/login')
                }
              } else {
                if (localStorage.getItem('token') && localStorage.getItem('USER_INFO')) {
                  window.location.replace(my.host + '/#/user/error')
                  return
                } else {
                  window.location.replace(my.host + '/#/user/login')
                  return
                }
              }
            }).catch(() => {
              this.$toast('请求失败！')
            })
          }
        }).catch(error => {
          if (error === 20005) {
            // this.$toast.clearAll(true)
          } else { this.$toast('请求失败！') }
        })
      } else {
        window.location.replace(hrefurl)
      }
    }
  }
}
</script>

